<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 18:01:25
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-30 17:57:11
 * @FilePath: /dsicm-admin-web/src/views/newPatientmanage/components/Tabs/index.vue
-->
<template>
  <div class="screeningPhysical-wrap">
    <div class="search-wrap">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-date-picker
            v-model="timeArr"
            type="daterange"
            size="medium"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="16">
          <div class="search-btns">
            <el-button size="small" @click="handlePreWeek">上一周</el-button>
            <el-button size="small" @click="handleNextWeek">下一周</el-button>
            <el-button
              type="primary"
              size="small"
              class="btn-bg"
              @click="handleSearch"
              >搜索</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <ul class="tab-wrap">
      <li
        v-for="(item, index) in tabList"
        :key="index"
        :class="activeTab === item ? 'active-bg' : ''"
        @click="changeTab(item)"
      >
        {{ item.secondCategoryName }}
      </li>
    </ul> -->
    <div class="table-content">
      <div class="table-text">
        <!-- <el-scrollbar style="height: 100%; font-size: 12px; width: 100%"> -->
          <el-table id="tableInfo" :data="tableData" :max-height="505" :header-cell-style="styleObj">
            <el-table-column prop="title" label="">
              <template slot-scope="scope">
                <div class="scope-title">
                  <span class="import" v-if="indicatorNames.indexOf(scope.row.title) > -1">重点</span>
                  <div>
                    <span style="display:block">{{ scope.row.title }}</span>
                    <span style="display:block;color:#1A7BFC;font-size:10px;" @click="viewChart(scope.row, scope.$index)">查看图表</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="standard" label="标准范围">

            </el-table-column>
            <el-table-column
              :prop="item.prop"
              v-for="(item, index) in tableTitleList"
              :key="index"
              :label="item"
              align="center"
            >
              <template slot-scope="scope">
                <span @click="showExarm(scope.row, scope.$index, item.prop)" style="vertical-align: top;margin-right: 12px;">{{
                  scope.row[(item + "value")]
                }}</span>
                <img style="vertical-align: middle;width: 5px;" src="../../../../assets/images/top.png" v-if="scope.row[(item+'status')]==1">
                <img style="vertical-align: middle;width: 5px;" src="../../../../assets/images/bottom.png" v-if="scope.row[(item+'status')]==-1">
              </template>
            </el-table-column>
          </el-table>
          <!--<el-pagination
                    style="margin-bottom:50px;text-align:right;margin-right:30px;margin-top:20px"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="current"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>-->
        <!-- </el-scrollbar> -->
      </div>
    </div>
    
    <el-dialog
      title=""
      :visible.sync="showPicTable"
      :close-on-click-modal="false"
      
      width="600px"
    >
      <ul class="tab-wrap" style="justify-content: flex-end;">
        <li
          v-for="(item, index) in tabList1"
          :key="index"
          :class="activeTab1 === item ? 'active-bg' : ''"
          @click="changeTab1(item)"
        >
          {{ item }}
        </li>
      </ul>
      <ve-line
        v-if="activeTab1 === '折线图'"
        :settings="chartSettings"
        :data="chartData"
        
      ></ve-line>
      <ve-histogram
        v-if="activeTab1 === '柱状图'"
        :data="chartData"
      ></ve-histogram>
    </el-dialog>
    <PreviewDialog ref="dialogRef" :paramData="paramData"> </PreviewDialog>
  </div>
</template>
<script>
import {
  getPhysicalSignMonitorData,
  getPatientDiseaseInspectionLogList,
  getDiseaseInspectionChar,
} from "../../api/index";
import PreviewDialog from "../../../treatment/components/RightContent/questionDialog";
import { selectListExam } from "../../../treatment/api/crossApi";
import VeLine from "v-charts/lib/line.common";
import VeHistogram from "v-charts/lib/histogram.common";
import moment from "moment";
export default {
  data() {
    // this.chartSettings = {
    //   labelAlias: {
    //     'maxReference': '最大标准值',
    //     'mixReference': '最小标准值',
    //     "number":'当前值'
    //   }
      
    // }
     
    return {
      activeTab: "计分类筛选评估表",
      tabList: ["计分类筛选评估表", "非计分类筛查评估表"],
      tableTitleList: [
        // { calendar: "2020-02-04", prop: "prop1",UpOrDown:'UpOrDown1' },
        // { calendar: "2020-02-04", prop: "prop2" },
        // { calendar: "2020-02-04", prop: "prop3" },
      ],
      tableData: [
        // {
        //   title: "NRS2002",
        //   prop1: "10",
        //   prop2: "20",
        //   prop3: "30",
        //   xList: [],
        //   yList: [],
        //   idObj: { prop1: "id1", prop2: "id2", prop3: "id3" },
        // },
        // {
        //   title: "NRS2002",
        //   prop1: "10",
        //   prop2: "20",
        //   prop3: "30",
        //   xList: [],
        //   yList: [],
        //   idObj: { prop1: "id1", prop2: "id2", prop3: "id3" },
        // },
        // {
        //   title: "NRS2002",
        //   prop1: "10",
        //   prop2: "20",
        //   prop3: "30",
        //   xList: [],
        //   yList: [],
        //   idObj: { prop1: "id1", prop2: "id2", prop3: "id3" },
        // },
      ],
      indicatorNames: [],
      current: 1,
      size: 10,
      total: 1,
      tableData1: [],
      current1: 1,
      size1: 10,
      total1: 10,
      paramData: {},
      timeArr: [
        moment().subtract("days", 6).format("yyyy-MM-DD"),
        moment().format("yyyy-MM-DD"),
      ],
      showPicTable: false,
      tabList1: ["柱状图", "折线图"],
      activeTab1: "折线图",
      chartData: {
        columns: ["日期", "参考最大值","参考最小值","实际值"],
        rows: [],
      },
      chartSettings: {},
      picData: [],
      styleObj:{
          background:'#FAFAFA',
          fontWeight: '500',
          color: '#333333',
          fontSize:'14px'
        }
    };
  },
  components: {
    PreviewDialog,
    VeLine,
    VeHistogram,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    
    // getPatientRelationInspectionCategory(this.userData.patientId).then((result) => {
    //   this.tabList = result.data
    //   this.activeTab =  result.data[0];
      // this.getQACountScoreList();
    // }).catch((err) => {
      
    // });
  },
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue && newValue.patientId) {
            this.getQACountScoreList();
          }
        }
      },
    },
  },
  methods: {
    /**
     * @description: tabs点击事件获取当前状态
     * @param {*}
     * @return {*}
     */
    handleSearch() {
      this.getQACountScoreList();
    },
    
    viewChart(data, index) {
      // getDiseaseInspectionChar({
      //   startTime: this.timeArr[0] + " 00:00:00",
      //   endTime: this.timeArr[1] + " 23:59:59",
      //   patientId: this.userData.patientId,
      //   inspectionId: data.inspectionId,
      // })
      //   .then((result) => {
          
          this.chartData.rows = [];
          if (data.chartDataList.length==0) {
            this.$message.info("当前无数据");
          }
          this.activeTab1 = "折线图";
          this.picData = data.chartDataList
          this.picData.forEach((v,index) => {
              this.chartData.rows.push({
                "日期": v.date,
                "参考最大值":Number(v.maxStandard),
                "实际值": Number(v.value),
                "参考最小值": Number(v.minStandard)
              });
          // });
          this.showPicTable = true;
        })
        .catch((err) => {});
    },
    changeTab(item) {
      this.activeTab = item;
      
    },
    changeTab1(item){
        this.activeTab1 = item;

    },
    handleShowPicTable(flag) {
      this.chartData.rows = [];
      this.bmiChartData.rows = [];
      this.activeTab1 = "折线图";

      this.picData.forEach((v) => {
        this.chartData.rows.push({
          date: v.turnoverDate,
          体重: v.weight,
        });
      });

      this.showPicTable = true;
    },
    showExarm(d, i, p) {
      selectListExam({
        answerSheetId: d.idObj[p],
      }).then((res) => {
        if (res.code == 0) {
          this.paramData = res.data;
          this.$refs.dialogRef.showVisible();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    viewEvent(row) {
      selectListExam({
        answerSheetId: row.id,
      }).then((res) => {
        if (res.code == 0) {
          this.paramData = res.data;
          this.$refs.dialogRef.showVisible();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    getQACountScoreList() {
      getPhysicalSignMonitorData({
        startDate: this.timeArr[0],
        endDate: this.timeArr[1],
        patientId: this.userData.patientId,
        isReport: false,// 疗程管理调用isReport为true 病人管理调用isReport为false
        // patientId:'1415243770742755330'
      }).then(result => {
        let data = result.data
        if (result.code === 0) {
          this.tableTitleList = data.headers;
          this.tableData = data.dataList;
          this.indicatorNames = data.indicatorNames
        }
      })

    },
    getQaChoiseList() {
      getPatientRelationInspectionCategory({
        countScore: false,
        startTime: this.timeArr[0] + " 00:00:00",
        endTime: this.timeArr[1] + " 23:59:59",
        userId: this.userData.patientId,
      })
        .then((result) => {
          this.tableData1 = result.data;
        })
        .catch((err) => {});
    },
    handlePreWeek() {
      this.timeArr = [
        moment(this.timeArr[0]).subtract("days", 6).format("YYYY-MM-DD"),
        moment(this.timeArr[0]).format("YYYY-MM-DD"),
      ];
      this.getQACountScoreList()
    },
    handleNextWeek() {
      this.timeArr = [
        moment(this.timeArr[1]).format("YYYY-MM-DD"),
        moment(this.timeArr[1]).add("days", 6).format("YYYY-MM-DD"),
      ];
      this.getQACountScoreList()
    },
  },
};
</script>
<style lang="less" scoped>
/* // @import './index'; */
.screeningPhysical-wrap {
  height: 100%;
}
.info-monitor {
  .search-wrap {
    background-color: #ffffff;
    padding: 15px;
    // margin-bottom: 16px;
  }
  .tab-wrap {
    padding: 10px 15px;
    background-color: #fff;
    cursor: pointer;
    display: flex;
    li {
      padding: 5px 10px;
      cursor: pointer;
    }
  }
  .active-bg {
    background-color: #1a7bfc;
    color: #fff;
  }
}
.table-content {
  height: calc(100% - 96px);
  .table-text {
    height: 100%;
    background: #ffffff;
    /deep/.el-scrollbar__view {
      height: 100%;
    }
  }
}
// 重点标识
.cell {
  .scope-title {
    display: flex;
    display: flex;
    // position: relative;
    align-items: center;
    padding-left: 54px;
    padding-bottom: 3px;
    .import {
      position: absolute;
      left: 10px;
      // top: 0;
      font-size: 12px;
      height: 26px;
      color: #1A7BFC;
      background: #E9F2FE;
      border: 1px solid #95C2FC;
      border-radius: 2px;
      padding: 0 4px;
    }
  }
}

/deep/.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  width: 30px;
}
</style>